import React from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import FooterNew from './FooterNew';

/**
 * Layout wrapper that provides consistent Navbar + Footer across all pages.
 */
export default function Layout({ children }) {
    const location = useLocation();
    const isAdminRoute = location.pathname.startsWith('/admin');
    const isLandingRoute = [
        '/soluciones/reducir-costos-aws',
        '/soluciones/automatizar-reportes',
    ].includes(location.pathname);

    return (
        <>
            {!isAdminRoute && !isLandingRoute && <a className="skip-link" href="#main-content">Saltar al contenido</a>}
            {!isAdminRoute && !isLandingRoute && <Navbar />}
            <main id="main-content">{children}</main>
            {!isAdminRoute && !isLandingRoute && <FooterNew />}
        </>
    );
}
